export const getNthPartOfSmallerDimension = (
  dimensionX: number,
  dimensionY: number,
  n = 10
) => Math.min(dimensionX, dimensionY) / n
